import { graphql } from "../gql";

export const setFindingStatusMutationDoc = graphql(`
  mutation setFindingStatus($input: SetFindingStatusInput!) {
    setFindingStatus(input: $input) {
      findings {
        id
        status
      }
      autoDeclinedFindings {
        id
        status
        batchClaimLineItemAudit {
          batchClaimLineItem {
            ibLineId
            alaRowId
          }
        }
      }
    }
  }
`);
